/* eslint-disable object-property-newline */
import React from 'react';
import { Relationship, Blueprint } from '@leverege/molten-core';
import { GeoPointRenderer, GeoShapeRenderer, LoadDataRenderer, GeoPointModel, GeoShapeModel } from "../../dataViewers/map/mapbox/renderers/index.js";
import Util from "./Util.js";
const create = ({
  blueprint,
  layerKey,
  layer
}) => {
  const {
    type: bType
  } = blueprint;
  const {
    type,
    path,
    objectType,
    dataPath,
    fallbackDataPath: fallback,
    attributePath,
    relationshipPath,
    sort,
    name
  } = layer;
  const model = type === 'point' ? GeoPointModel : GeoShapeModel;
  const renderer = type === 'point' ? GeoPointRenderer : GeoShapeRenderer;
  const layerName = `${bType}:${layerKey}`;
  const id = `blueprint.${layerName}.MapLayer`;
  const bp = Blueprint.getByType(objectType);
  const attribute = bp.getAttribute(attributePath);
  let relationship = Relationship.getByPath(relationshipPath);
  return {
    id,
    sort,
    layerName,
    matches: {
      client: 'MapDataViewer',
      path,
      objectType: bType
    },
    createModel: Util.newModelCreator(model, {
      name,
      objectType,
      layerName
    }),
    create(props) {
      const {
        delegate,
        match
      } = props;
      relationship = relationship ? relationship.createResolved(match) : relationship;
      const pActions = delegate.parent();
      const url = `${pActions.getInterfaceUrl()}/${dataPath.join('/')}`;
      const altUrl = fallback ? `${pActions.getInterfaceUrl()}/${Array.isArray(fallback) ? fallback.join('/') : fallback}` : null;
      const childActions = pActions.child(relationship.attribute.path);
      if (!dataPath && !childActions) {
        // eslint-disable-next-line no-console
        console.warn('Expected to find relationship attribute on parent item', `Actions ID: ${pActions.id}`, relationship);
        return null;
      }
      return /*#__PURE__*/React.createElement(LoadDataRenderer, {
        ...props,
        childPath: url,
        fallbackChildPath: altUrl,
        renderer,
        // : GeoShapeRenderer, 
        delegate: childActions || pActions,
        key: layerName,
        relationship,
        attributeName: `${objectType}.${attributePath}`,
        layerId: `grp-${relationship.path}:${relationship.attributeName}`,
        attribute
      });
    }
  };
};
export default {
  create
};